Ext.define('SA.CrosstabDefaultCell', {
    html: [
        '<div class="sa-crosstab-default-cell-section sa-crosstab-default-cell-vertical-section">',
            '<svg class="sa-crosstab-default-cell-arrow sa-crosstab-default-cell-vertical-arrow">',
                '<use href="#sa-icon-crosstab-arrow-vertical"></use>',
            '</svg>',
            '<span class="sa-crosstab-default-cell-value sa-crosstab-default-cell-vertical-value"></span>',
        '</div>',
        '<div class="sa-crosstab-default-cell-section sa-crosstab-default-cell-index-section">',
            '<div class="sa-crosstab-body-cell-index-label">Index</div>',
            '<span class="sa-crosstab-default-cell-value sa-crosstab-default-cell-index-value"></span>',
        '</div>',
        '<div class="sa-crosstab-default-cell-section sa-crosstab-default-cell-horizontal-section">',
            '<svg class="sa-crosstab-default-cell-arrow sa-crosstab-default-cell-horizontal-arrow">',
                '<use href="#sa-icon-crosstab-arrow-horizontal"></use>',
            '</svg>',
            '<span class="sa-crosstab-default-cell-value sa-crosstab-default-cell-horizontal-value"></span>',
        '</div>'
    ],

    constructor({parent}) {
        this.el = parent.appendChild(document.createElement('div'));
        this.el.className = 'sa-crosstab-default-cell';
        this.el.innerHTML = this.html.join('');

        this.el.querySelector('.sa-crosstab-default-cell-vertical-section').addEventListener('mouseenter', this.onVerticalSectionMouseEnter.bind(this));
        this.el.querySelector('.sa-crosstab-default-cell-index-section').addEventListener('mouseenter', this.onIndexSectionMouseEnter.bind(this));
        this.el.querySelector('.sa-crosstab-default-cell-horizontal-section').addEventListener('mouseenter', this.onHorizontalSectionMouseEnter.bind(this));
    },

    fireEvent(type, target) {
        var detail = {el: target, state: this.state};

        this.el.dispatchEvent(new CustomEvent(type, {bubbles: true, detail}));
    },

    getTplData(state) {
        var formatPercent = id => SA.CrosstabBodyCell.formatPercent(state.data[`% of ${id}`]);

        if (state.empty) {
            return {index: 'N/A', horizontal: 'N/A', vertical: 'N/A'};
        }

        return {
            index: SA.formatValue(state.data.index, '%d'),
            vertical: formatPercent(state.ids.top),
            horizontal: formatPercent(state.ids.left)
        };
    },

    onHorizontalSectionMouseEnter(ev) {
        if (this.state.data && this.state.ids.top !== 'total') {
            this.fireEvent('horizontalpercent:shouldshowtooltip', ev.target);
        }
    },

    onIndexSectionMouseEnter(ev) {
        if (this.state.data && this.state.ids.left !== 'total' && this.state.ids.top !== 'total') {
            this.fireEvent('index:shouldshowtooltip', ev.target);
        }
    },

    onVerticalSectionMouseEnter(ev) {
        if (this.state.data && this.state.ids.left !== 'total') {
            this.fireEvent('verticalpercent:shouldshowtooltip', ev.target);
        }
    },

    setState(state) {
        var tplData = this.getTplData(state);

        this.el.classList.toggle('sa-crosstab-default-cell-null', state.empty);
        this.el.classList.toggle('sa-crosstab-default-cell-dragging', state.dragging);

        this.el.querySelector('.sa-crosstab-default-cell-index-value').textContent = tplData.index;
        this.el.querySelector('.sa-crosstab-default-cell-vertical-value').textContent = tplData.vertical;
        this.el.querySelector('.sa-crosstab-default-cell-horizontal-value').textContent = tplData.horizontal;

        this.state = state;
    },

    setVisible(visible) {
        this.el.classList.toggle('sa-crosstab-default-cell-hidden', !visible);
    }
});